/**
 * Word that this session has saved a workspace, with the time the save wrote as its lastSaved.
 * The library list is read only now and then, so it does not know of saves made since: what
 * reads other workspaces by their lastSaved (the references shared across a project,
 * hooks/useProjectReferences.ts) listens here, and so sees a workspace just left as changed.
 */
type Listener = (workspaceId: string, savedAt: number) => void;

const listeners = new Set<Listener>();

export const noteWorkspaceSaved = (workspaceId: string, savedAt: number): void => {
    for (const listener of listeners) {
        try { listener(workspaceId, savedAt); } catch (error) { console.warn('[workspaceSaves] A listener failed:', error); }
    }
};

/** Calls `listener` after each save; returns what stops it */
export const onWorkspaceSaved = (listener: Listener): (() => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
};
